import type {TncDto, TncInfoDto} from "~/types/common/backend-dto-types";
import type {HconFetchBuilder} from  "~/composables/hcon-fetch-builder";

export const CommonUtil = {
  fetchBuild: {
    // 약관 목록 조회
    terms: (hcTncUsePntmCd: string) => {
      return useHconFetchBuilder().get<AjaxResult<TncDto>>(`/api/v1/common/tnc/${hcTncUsePntmCd}`).build();
    },
    // 약관 조회
    term: (hcTncKndCd: string, hcTncUsePntmCd: string) => {
      return useHconFetchBuilder().get<AjaxResult<TncInfoDto>>(`/api/v1/common/tnc/${hcTncKndCd}/${hcTncUsePntmCd}`).preventErrorNotify().build();
    }
  }
}